import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { PauseCircle, FileSignature } from "lucide-react";

const box = "mb-4 rounded-xl border px-4 py-3 flex flex-wrap items-center gap-3 text-sm";

export function AccountStatusBanners({ compliance }) {
  const navigate = useNavigate();
  const [sent, setSent] = useState(false);
  if (!compliance) return null;
  const ask = async () => {
    try { await api.post("/me/reactivation-request"); setSent(true); toast.success("Richiesta inviata: ti avvisiamo appena l'account è riattivato"); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore, riprova"); }
  };
  const requested = sent || compliance.reactivation_requested;
  return (<>
    {compliance.inactivity_suspended && <div className={`${box} border-red-500/40 bg-red-500/10`} data-testid="inactivity-suspended-banner">
      <PauseCircle className="w-4 h-4 text-red-500 shrink-0" />
      <span className="flex-1 min-w-[200px]"><strong>Account sospeso per inattività.</strong> Il tuo credito resta registrato ma non si può usare finché l'account non viene riattivato.</span>
      {requested ? <span className="text-xs text-muted-foreground" data-testid="reactivation-requested">Richiesta di riattivazione inviata</span>
        : <Button size="sm" className="ml-auto bg-emerald-600 hover:bg-emerald-700 text-white" onClick={ask} data-testid="reactivation-request-button">Chiedi la riattivazione</Button>}
    </div>}
    {compliance.resign_required && <div className={`${box} border-amber-500/40 bg-amber-500/10`} data-testid="resign-banner">
      <FileSignature className="w-4 h-4 text-amber-500 shrink-0" />
      <span className="flex-1 min-w-[200px]"><strong>Contratto aggiornato.</strong> Rifirmalo con il codice SMS{compliance.resign_deadline ? ` entro il ${new Date(compliance.resign_deadline).toLocaleDateString("it-IT")}` : ""}{compliance.specific_required ? ": contiene le nuove regole su inviti e inattività." : "."}</span>
      <Button size="sm" className="ml-auto bg-emerald-600 hover:bg-emerald-700 text-white" onClick={() => navigate("/app/compliance")} data-testid="resign-banner-cta">Rifirma ora</Button>
    </div>}
  </>);
}
